import { CustomAppLayout } from '../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../context/GlobalStateContext';




import { Alert, Box, Button, Container, KeyValuePairs, Link, MixedLineBarChart, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addHours, format, parse } from 'date-fns';
import { fetchWithWatch } from '../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../resources/types';
import { buildBreadcrumbItems, getAirport, getCookie, getUrlVersion, setLoading, storeJWT } from '../../commons/functions';


const pageSize = 20;
interface Access {
    idAcceso: number;
    isActive: number;
    isMantAcceso: number;
    relay: number;
    acceso: string;
    isOnline: number;
    manualOpenEnable: number;
    idSector: number;
    sector: string;
    label: string;
    id: string;
    description?: string
    disabled?: boolean;
}
interface MyBoardItemData {
    title: string;
    description?: string;
    content: React.ReactNode;
    footer?: React.ReactNode;
    actions?: React.ReactNode;
}
type LogItem = { idLog: number; fecha: string; hora: string; status: string; log: string; user: string; objTime: string; };
interface Sector { idSector: number; sector: string; }

export const HomePage = () => {
    //const storeAdmin = useStoreAdmin();
    const globalState = useGlobalState();

    const [timeAirport, setTimeAirport] = useState("- -:- -");
    const [timeUTC, setTimeUTC] = useState("- -:- -");
    const [airport, setAirport] = useState<any>();
    const [user] = useState<ItemUser>({} as ItemUser);

    const { name } = useGlobalState();

    const { navigate } = useRouter();


    const { data } = useGlobalState();
    const { parameters, idAirport } = useGlobalState();
    useEffect(() => {
        setTimeout(() => {
            handleRefresh();
        }, 100);
    }, [idAirport]);



    const handleRefresh = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/config/airport/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();

            if (data.code === 0) {
                storeJWT(data);
                setAirport(data.airport);
                setTimeAirport(data.timeAirport);
                setTimeUTC(data.timeUTC);

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        handleRefresh();
    }, []);

    const Wrapper = React.Fragment;
    const { menu } = useGlobalState();
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween size="s" direction='vertical'>
                        <Header variant='h1'
                            description={`${getAirport(airport?.idAirport, data)?.airport} · ${getAirport(airport?.idAirport, data)?.city}`}
                        >Aeropuerto {getAirport(airport?.idAirport, data)?.IATA}</Header>
                        <SpaceBetween size="s" direction='horizontal'>
                            <Container header={<Header variant='h2'>Hora Local</Header>}>
                                <Link variant="awsui-value-large">{timeAirport || "--:--"}
                                </Link>
                            </Container>
                            <Container header={<Header variant='h2'>Hora UTC</Header>}>
                                <Link variant="awsui-value-large">{timeUTC || "--:--"}
                                </Link>
                            </Container>
                            <Container header={<Header variant='h2'>Huso GMT</Header>}>
                                <Box textAlign='center'>
                                    <Link variant="awsui-value-large">{airport?.GMT > 0 ? "+" : ""}{airport?.GMT || "0"}
                                    </Link>
                                </Box>
                            </Container>

                        </SpaceBetween>
                        {airport && airport.GMTNextSync && airport.GMTNextSync !== "" && airport.GMTNextValue !== undefined && (
                            <Alert type="info"
                                header="Programación de cambio de huso horario"
                            >
                                El día <strong>{airport.GMTNextSync ? airport.GMTNextSync : "--/--/----"}</strong> a las <strong>{airport.GMTNextSync ? format(addHours(parse(airport.GMTNextSync, "dd-MM-yyyy", new Date()), -1 * airport.GMTNextValue), "HH:mm") : "--:--"}</strong> horas UTC, el nuevo huso horario será GMT <strong>{airport.GMTNextValue >= 0 ? `+${airport.GMTNextValue}` : `${airport.GMTNextValue}`}</strong>.
                            </Alert>
                        )}
                    </SpaceBetween ></>
            }
        />
    );
};
/*


                            <div>
                                {movements && movements.length > 0 && (
                                    <Container header={
                                        <Header variant="h2">
                                            Últimos movimientos
                                        </Header>
                                    }>
                                        <TableMovements showUser={false} visible filter={false} movements={movements} />
                                    </Container>
                                )}
                            </div>
                            <div>
                                <Chart />
                            </div>

                            

                        <div>
                            {data.usersTypes &&
                                data.usersTypes.map((ut: { color: string | "grey"; userType: string | undefined; ut: string }) => (
                                    <BadgeCustom key={ut.userType} color={ut.color}>
                                        {ut.ut}
                                    </BadgeCustom>
                                ))
                            }
                        </div>

                        <div>
                            {colors2.map((c, i) => (
                                <BadgeCustom key={i} color={c}>
                                    {c}
                                </BadgeCustom>
                            ))}
                        </div>

                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 6, m: 6, default: 12 } },
                            { colspan: { l: 8, m: 8, default: 12 } },
                            { colspan: { l: 4, m: 4, default: 12 } },
*/

function Head1() {
    return (
        <Container fitHeight>
            <Header variant="h2" description={`Viewing data from REGION Region`}>
                Service overview - <em>new</em>
            </Header>
            <KeyValuePairs
                columns={4}
                items={[
                    {
                        label: 'Próximas reservas', value: (<Link variant="awsui-value-large" href="#">1</Link>),
                    },
                    {
                        label: 'Chequeos pendientes',

                        value: (
                            <Link variant="awsui-value-large" href="#" ariaLabel="Volumes (126)">
                                2
                            </Link>
                        ),
                    },
                    {
                        label: 'Cuenta club',
                        value: (
                            <h1>
                                $ -321.554
                            </h1>
                        ),
                    },
                    {
                        label: 'Cuenta casino',
                        value: (
                            <Link variant="info">
                                $16.3280
                            </Link>
                        ),
                    },
                ]}
            />
        </Container>)
}


function Chart() {
    return (
        <Container fitHeight>

            <Header variant="h2" description={`Planeadir`}>
                Experiencia reciente - <em>new</em>
            </Header>
            <MixedLineBarChart
                series={[
                    {
                        title: "Costs",
                        type: "bar",
                        data: [
                            { x: "Jun 2019", y: 6562 },
                            { x: "Jul 2019", y: 8768 },
                            { x: "Aug 2019", y: 9742 },
                            { x: "Sep 2019", y: 10464 },
                            { x: "Oct 2019", y: 16777 },
                            { x: "Nov 2019", y: 9956 },
                            { x: "Dec 2019", y: 5876 }
                        ],
                        valueFormatter: e =>
                            "$" +
                            e.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                    },
                    {
                        title: "Costs last year",
                        type: "line",
                        data: [
                            { x: "Jun 2019", y: 5373 },
                            { x: "Jul 2019", y: 7563 },
                            { x: "Aug 2019", y: 7900 },
                            { x: "Sep 2019", y: 12342 },
                            { x: "Oct 2019", y: 14311 },
                            { x: "Nov 2019", y: 11830 },
                            { x: "Dec 2019", y: 8505 }
                        ],
                        valueFormatter: e =>
                            "$" +
                            e.toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })
                    },
                ]}
                xDomain={[
                    "Jun 2019",
                    "Jul 2019",
                    "Aug 2019",
                    "Sep 2019",
                    "Oct 2019",
                    "Nov 2019",
                    "Dec 2019"
                ]}
                yDomain={[0, 20000]}
                i18nStrings={{
                    yTickFormatter: function l(e) {
                        return Math.abs(e) >= 1e9
                            ? (e / 1e9).toFixed(1).replace(/\.0$/, "") +
                            "G"
                            : Math.abs(e) >= 1e6
                                ? (e / 1e6).toFixed(1).replace(/\.0$/, "") +
                                "M"
                                : Math.abs(e) >= 1e3
                                    ? (e / 1e3).toFixed(1).replace(/\.0$/, "") +
                                    "K"
                                    : e.toFixed(2);
                    }
                }}
                ariaLabel="Mixed bar chart"
                height={300}
                xScaleType="categorical"
                xTitle="Budget month"
                yTitle="Costs (USD)"
                empty={
                    <Box textAlign="center" color="inherit">
                        <b>No data available</b>
                        <Box variant="p" color="inherit">
                            There is no data available
                        </Box>
                    </Box>
                }
                noMatch={
                    <Box textAlign="center" color="inherit">
                        <b>No matching data</b>
                        <Box variant="p" color="inherit">
                            There is no matching data to display
                        </Box>
                        <Button>Clear filter</Button>
                    </Box>
                }
            />

        </Container>
    );
}

function buildCounterMessage({ pax, shifts }: { pax: number; shifts: number }) {
    const hasPax = pax > 0;
    const hasShifts = shifts > 0;

    const paxText =
        pax === 0 ? "" :
            pax === 1 ? "1 PAX" :
                `${pax} PAX`;

    const shiftsText =
        shifts === 0 ? "" :
            shifts === 1 ? "1 turno" :
                `${shifts} turnos`;

    // No counters?
    if (!hasPax && !hasShifts) return "";

    // Only PAX
    if (hasPax && !hasShifts) return `Tienes ${paxText} a la venta`;

    // Only shifts
    if (!hasPax && hasShifts) return `Tienes ${shiftsText} a la venta`;

    // Both present
    return `Tienes ${shiftsText} y ${paxText} a la venta`;
}